<template>
  <div>
    <sidebar></sidebar>
    <div class="allLayer" style="position: relative">
      <div class="CarouselPhone">
        <v-carousel show-arrows-on-hover cycle hide-delimiters>
          <template v-slot:prev="{ on, attrs }">
            <v-icon x-large v-bind="attrs" v-on="on">mdi-chevron-left</v-icon>
          </template>
          <template v-slot:next="{ on, attrs }">
            <v-icon x-large v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
          </template>
          <v-carousel-item v-for="(item, index) in textupdate.photos" :key="item" :src="item"></v-carousel-item>
        </v-carousel>
      </div>

      <div class="TopLayer">
        <h1>溫馨雙人房</h1>
        <p>Cozydouble Room</p>
        <hr />

        <!-- desc text input -->
        <div class="desc-Block">
          <p style="white-space: pre-wrap" v-show="!DisplaySwitch">
            {{ textupdate.title }}
            <br />
          </p>
        </div>

        <a href="https://pescadores.ezhotel.com.tw/3">
          <v-btn rounded color="#F29100" dark x-large class="px-16">線上訂房</v-btn>
        </a>

        <!-- desc text input -->
        <div class="desc-Block">
          <p style="white-space: pre-wrap" v-show="!DisplaySwitch">
            {{ textupdate.desc }}
            <br />
          </p>
        </div>
        <!-- desc text input -->
      </div>

      <div class="Carousel">
        <v-carousel show-arrows-on-hover cycle hide-delimiters>
          <template v-slot:prev="{ on, attrs }">
            <v-icon x-large v-bind="attrs" v-on="on">mdi-chevron-left</v-icon>
          </template>
          <template v-slot:next="{ on, attrs }">
            <v-icon x-large v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
          </template>
          <v-carousel-item v-for="(item, index) in textupdate.photos" :key="item" :src="item"></v-carousel-item>
        </v-carousel>
      </div>
    </div>

    <footer>
      <FooterNav></FooterNav>
    </footer>
  </div>
</template>

<script>
import sidebar from "@/components/The_Sidebar.vue";
import FooterNav from "@/components/footer.vue";
export default {
  components: {
    sidebar,
    FooterNav,
  },
  data() {
    return {
      showMenu: false,
      hidden: true,
      ChangeButtonOpen: false,
      dialog: false,
      ErrorDialog: false,
      isTransform: true,

      DisplaySwitch: false,

      //<!-- Tool bar -->
      direction: "top",
      fab: false,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: false,
      bottom: true,
      left: true,
      transition: "scale-transition",

      //Update參數
      textupdate: {
        title: "",
        desc: "",
        photos: [],
        id: 4,
      },
    };
  },
  mounted() {
    let vm = this;

    // 首次渲染抓資料
    let config = {
      method: "post",
      url: "https://think-x-tech.synology.me/hotel_system/public/api/roomtype/show",
      headers: {
        Authorization: "Bearer 267|2cEoJMpGw63gFpsaK8crj6sy6kxPPmdQCCgtWKFF",
      },
      data: { "id": vm.textupdate.id } // 依 id 區分房型
    };

    axios(config)
      .then(function (response) {
        console.log("POST成功");
        vm.textupdate.title = response.data[0].title;
        vm.textupdate.desc = response.data[0].desc;
        response.data.map((photo_data) => {
          vm.textupdate.photos.push(
            'https://think-x-tech.synology.me/hotel_system/public/images/' + photo_data.path
          )
        })
      })
      .catch(function (error) {
        console.log(error);
        console.log("失敗");
      });
  },

  methods: {
    ButtonEvent() {
      let str = localStorage.getItem("LoginStatus");
      // 登入狀態時雙擊效果才會出來
      if (str) {
        this.DisplaySwitch = true;
      } else {
        this.DisplaySwitch = false;
      }
    },

    //輸入完input欄位按下enter將欄位關閉
    ButtonEventClose() {
      this.DisplaySwitch = false;
    },

    //查看圖片上傳 Form-Data File 有沒有東西
    uploadFile() {
      console.log(this);
    },


  },
};
</script>

<style lang="scss" scoped>
a:hover,
a:link,
a:active,
a:visited {
  text-decoration: none;
  color: white;
}

.CarouselPhone {
  display: none;
}

.allLayer {
  display: flex;
  justify-content: space-around;
  padding: 10% 0 15% 0;
  p {
    line-height: 2;
    font-size: 18px;
    white-space: pre-wrap;
  }
}
.TopLayer {
  width: 40vw;
  hr {
    border: 0;
    height: 3px;
    width: 20%;
    margin: 2% 0;
    background-color: gray;
  }
}
.Carousel {
  // margin-top: 10%;
  width: 40vw;
}
.desc-Block {
  padding: 4% 0;
}
.ChangeButton {
  position: fixed;
  bottom: 5%;
  left: 3%;
  display: flex;
  flex-direction: column;
  z-index: 1;
}
/* This is for documentation purposes and will not be needed in your application */
#create .v-speed-dial {
  position: fixed;
}

#create .v-btn--floating {
  position: relative;
}

.carousel-img-upload {
  display: flex;
  position: absolute;
  right: 15%;
  bottom: 33%;
}
.carousel-img-upload label {
  margin: 0 3%;
}

@media screen and (min-width: 960px) and (max-width: 1264px) {
  .allLayer {
    flex-direction: column;
    align-items: center;
    p {
      line-height: 2;
      font-size: 25px;
    }
  }
  .TopLayer {
    width: 90vw;
    margin-top: 5%;
  }
  .Carousel {
    width: 90vw;
  }
  .desc-Block {
    padding: 5% 0;
  }
}

@media screen and (min-width: 600px) and (max-width: 960px) {
  .allLayer {
    flex-direction: column;
    align-items: center;
  }
  .TopLayer {
    width: 90vw;
    margin-top: 5%;
  }
  .Carousel {
    width: 90vw;
  }
  .desc-Block {
    padding: 5% 0;
  }
}

@media screen and (max-width: 600px) {
  .CarouselPhone {
    display: block;
    width: 100vw;
  }
  .Carousel {
    display: none;
  }
  .allLayer {
    flex-direction: column;
    align-items: center;
    padding: 0% 0 15% 0;
  }
  .TopLayer {
    width: 90vw;
    margin-top: 5%;
  }
  .Carousel {
    width: 90vw;
  }
  .desc-Block {
    padding: 10% 0;
  }
}
</style>
